import { useState } from "react";
import { Phone } from "lucide-react"; // tylko jeśli masz Lucide lub Heroicons – opcjonalnie

export default function ReservationAboutSection() {
  const [hovered, setHovered] = useState(false);

  return (
    <section className="bg-light2 py-10 px-4 relative z-20 h-auto md:h-[520px] shadow-lg">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-0 relative z-10 -mt-20 shadow-[0_10px_30px_rgba(0,0,0,0.15)]">
        {/* Rezerwacje */}
        <div className="col-span-1 flex flex-col">
          <div className="bg-white shadow p-6 text-center flex flex-col justify-center h-[300px]">
            <h2 className="text-2xl font-heading mb-4">Rezerwacje</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Zadzwoń do nas, aby zarezerwować stolik w naszej restauracji. Rezerwacje przyjmujemy na ten sam dzień.
            </p>
            <a
              href="tel:668291465"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              className="inline-flex items-center justify-center border border-primary px-4 py-2 text-sm font-semibold text-primary hover:bg-primary hover:text-white transition-colors duration-300 rounded"
            >
              <span
                className={`transition-all duration-300 ${
                  hovered ? 'opacity-0 scale-90 absolute' : 'opacity-100 scale-100 relative'
                }`}
              >
                ZAREZERWUJ STOLIK
              </span>
              <span
                className={`flex items-center gap-2 transition-all duration-300 ${
                  hovered ? 'opacity-100 scale-100 relative' : 'opacity-0 scale-90 absolute'
                }`}
              >
                <Phone size={16} /> 668 291 465
              </span>
            </a>
          </div>
            <img
              src="/images/foto2.jpg"
              alt="Wnętrze restauracji"
              className="w-full object-cover h-[300px] hidden md:block"
            />
        </div>

        {/* Zdjęcie i opis */}
        <div className="col-span-3 flex flex-col">
          <img
            src="/images/foto19.jpg"
            alt="Widok zewnętrzny restauracji"
            className="w-full object-cover h-[300px]"
          />
          <div className="bg-white shadow p-6 text-center flex flex-col justify-center h-[300px]">
            <h2 className="text-2xl font-heading mb-4">O nas</h2>
            <p className="text-gray-600 text-sm leading-relaxed max-w-2xl mx-auto">
              Restauracja Magiczna w Tychach to miejsce, gdzie tradycja spotyka się z wyjątkowym smakiem i atmosferą.
              Specjalizujemy się w organizacji przyjęć okolicznościowych takich jak wesela, komunie, chrzciny czy spotkania biznesowe.
              Nasza kuchnia oparta jest na staropolskich recepturach, a zespół zadba o to, aby każda uroczystość była niezapomniana.
              Serdecznie zapraszamy do odwiedzin i rezerwacji.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
